export const mainTransition = {
  duration: 0.3,
  delay: 0.2,
};
